module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/LA-Juvie-Yard2_BW-01b80a94f9b1810e70669165adc4f717.jpg";